<h1 mat-dialog-title class="fixed-min">
  Detalles de la sesi&oacute;n:
  <span class="title-blue-bimbo-cap">"{{ titulo }}"</span>
</h1>
<hr />
<div mat-dialog-content>
  <!-- general data -->
  <div class="session-details container p-4 border rounded shadow-sm bg-light">
    <div class="text-center mb-4">
      <h1 class="fw-bold">{{ inputData?.titulo }}</h1>
    </div>

    <div class="table-responsive">
      <table class="table table-borderless">
        <tbody>
          <!-- 1 locator id and event name -->
          <tr>
            <td class="fw-bold">ID localizador:</td>
            <td>{{ inputData?.IdLocalizador }}</td>
            <td class="fw-bold">Evento:</td>
            <td>{{ inputData?.nombreEvento }}</td>
          </tr>

          <!-- 2 email and person number  -->
          <tr>
            <td class="fw-bold d-flex align-items-center">Email:</td>
            <td>
              <span
                class="truncate-text d-inline-block"
                style="max-width: 200px">
                {{ inputData?.correoInstructor }}
              </span>
            </td>
            <td class="fw-bold d-flex align-items-center">
              N&uacute;mero de colaborador:
            </td>
            <td>{{ inputData?.numeroPersona ?? "Dato faltante" }}</td>
          </tr>

          <!-- 3 master qr -->
          <tr>
            <td class="fw-bold d-flex align-items-center">QR maestro:</td>
            <td>{{ inputData?.QrMeastro ? "Sí" : "No" }}</td>
            <td class="fw-bold d-flex align-items-center">Partes:</td>
            <td class="truncate-text">
              {{ inputData?.totalPartesReales }}
            </td>
          </tr>
          <!-- 4 creation date -->
          <tr>
            <td class="fw-bold d-flex align-items-center">
              Fecha de creación:
            </td>
            <td colspan="3">
              {{ inputData?.fechaAlta | date: "dd-MMM-yyyy" : "" : "es-MX" }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="d-flex justify-content-center align-content-center mb-2 mt-3">
    <div class="col-3 mx-1 p-1">
      <button
        (click)="closepopup()"
        class="btn btn-secondary-cap"
        type="button">
        <span>Cerrar</span>
      </button>
    </div>
  </div>
</div>
